module.exports = __webpack_public_path__ + "static/img/home_picture_03.b946bfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/home_picture_03.png
// module id = XzME
// module chunks = 0